import type { ObjectInspectorComponent } from './types';

const registry = new Map<string, ObjectInspectorComponent>();

export const registerInspector = (type: string, component: ObjectInspectorComponent): void => {
  registry.set(type, component);
};

export const getInspector = (type: string | undefined): ObjectInspectorComponent | undefined => {
  if (!type) return undefined;
  return registry.get(type);
};
